import { useSelector } from 'react-redux';
import { licenseSelector } from 'state/selectors/license';
import { Link } from '@material-ui/core';
import { contactCustomerSuccess } from 'common/services/contactCustomerSuccess.service';

const MaxReposIndicator = () => {
  const license = useSelector(licenseSelector);
  const maxRepos = license?.maxRepos;

  return (
    <div className='text-red-500 ml-auto text-xs'>
      Monitoring <b>{maxRepos} repositories</b> - you've reached your plan's
      limit.
      <Link className='pl-2' onClick={contactCustomerSuccess}>
        Contact Customer Success
      </Link>
    </div>
  );
};

export default MaxReposIndicator;
